import { IJbpSalesTypeItem } from '../../../../services/partner360/configuration/models'

export const parseSalesTypeButtons = (json: string = '[]'): IJbpSalesTypeItem[] => {
  try {
    return JSON.parse(json)
  } catch (e) {
    return []
  }
}
